export default __webpack_public_path__ + "media/images/temporary/fun-mud-run-00797365fd066ae722f207879f010dfe.jpg";